import { ReactElement } from 'react';
import { Formik } from 'formik';
import { Body } from './Body';
import { Props } from './UpdateForm.types';
import { FIELD_NAME } from './UpdateFormContainer.types';

export const UpdateForm = ({
  newslettersData,
  updateNewslettersRecord,
  email,
  onActiveSubscriberChange,
  onCheckboxChange,
  onSubmit,
  wereCheckboxesChanged,
}: Props): ReactElement => {
  const initialValues = {
    [FIELD_NAME.activeSubscriber]: newslettersData.activeSubscriber,
    ...newslettersData.subscriptions,
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      <Body
        updateNewslettersRecord={updateNewslettersRecord}
        email={email}
        onActiveSubscriberChange={onActiveSubscriberChange}
        onCheckboxChange={onCheckboxChange}
        wereCheckboxesChanged={wereCheckboxesChanged}
      />
    </Formik>
  );
};
